import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import SidebarFan from "@/components/SidebarFan.vue";
import { prefetchWorklist } from "@/composables/useWorklistTable";
import { activeSectionFor, sectionsFor } from "@/constants/worklistSections";
import { useRequirementsStore } from "@/stores";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SidebarWorklistFan',
    props: {
        expanded: { type: Boolean },
        isMobile: { type: Boolean }
    },
    emits: ["navigate"],
    setup(__props) {
        const route = useRoute();
        const requirementsStore = useRequirementsStore();
        const modules = computed(() => requirementsStore.visibleModules ?? []);
        const active = computed(() => (route.name === "worklist" ? activeSectionFor(modules.value, route.query) : null));
        const items = computed(() => {
            const sections = sectionsFor(modules.value);
            if (sections.length < 2)
                return [];
            return sections.map((section) => ({
                key: section.key,
                label: section.label,
                icon: section.icon,
                to: { name: "worklist", query: section.query },
                active: section.key === active.value,
                prefetch: () => prefetchWorklist(section.query),
            }));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(SidebarFan, {
                icon: "mdi-format-list-checks",
                label: "Worklist",
                route: "worklist",
                items: items.value,
                expanded: __props.expanded,
                "is-mobile": __props.isMobile,
                active: _unref(route).name === 'worklist',
                onNavigate: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('navigate')))
            }, null, 8, ["items", "expanded", "is-mobile", "active"]));
        };
    }
});
